export const DEBUG = process.env.NODE_ENV === 'development';
export const SLOW_DL = DEBUG && false;